import type { Card } from '../../types';

/** §14 worked card (ADR-0015 §17 mapping). Passive: when the opponent rolls a 1,
 * freeze their highest-cost still-playable card for 1 turn. */
export const COLD_SNAP: Card = {
  id: 'cold-snap',
  name: 'Cold Snap',
  type: 'trap',
  rarity: 'common',
  size: { w: 1, h: 1 },
  cost: [],
  effects: [{ kind: 'freezeCard', select: 'highestCostPlayable' }],
  trap: { variant: 'passive', trigger: { kind: 'opponentRollFace', value: 1 } },
};
